import { css } from "@emotion/css";
import { FontSizeInPx, FontWeight } from "@snapchat/snap-design-system";

export const actionButton = css`
    &.sds-button.link {
        padding-left: 0;
    }

    span {
        display: inline-flex;
        align-items: center;
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.MEDIUM};
    }
`;
